import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'eui-card-footer-menu-content',
    templateUrl: './eui-card-footer-menu-content.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EuiCardFooterMenuContentComponent {

    @Input() tooltipText = 'More options';

    @HostBinding('class') string = 'eui-card-footer-menu-content';

    constructor() {
    }
}
